import React, {useEffect, useState} from "react";
import {Button, Col, FormGroup, Label, Row, Spinner} from "reactstrap";
import Select from "react-select";
import {FormControl} from "react-bootstrap";
import {getSelectedObject} from "../../util/Helper";
import {NotificationManager} from "react-notifications";

const Experience = (props) => {
  const [experience, setExperience] = useState("");
  const years = [
    {
        value: 0,
        label: "0 years",
    },
      {
      value: 1,
      label: "1 year",
    },
    {
      value: 2,
      label: "2 years",
    },
    {
      value: 3,
      label: "3 years",
    },
    {
      value: 4,
      label: "4 years",
    },
    {
      value: 5,
      label: "5 years",
    },
    {
      value: 6,
      label: "6 years",
    },
    {
      value: 7,
      label: "7 years",
    },
    {
      value: "8+",
      label: "8+ years",
    },
  ];
  useEffect(() => {
      console.log({...props.experience});
    setExperience({ ...props.candidate });
  }, []);


    const isFieldEnabled = (fieldName) =>
        props.experience.fields[fieldName]?.enabled;

    const theLabelName = (fieldName) => props.experience.fields[fieldName]?.label;

  const handleChange = (e) => {
    setExperience({
      ...experience,
      [e.target.name]: e.target.value,
    });
  };


  const handleValidation = () => {
    // const { yearsOfExperience } = experience;
    //
    // // Check if yearsOfExperience is filled
    // if (!yearsOfExperience) {
    //   return false;
    // }
    return true;
  };


    const handleNext = () => {
    if (handleValidation()) {
      props.setCandidate({ ...props.candidate, ...experience });

        console.log(props.progress);
        // props.setProgress(50);
        const newProgress = (props.progress || 0) + props.progressIncrement;
        console.log(newProgress);

        props.setProgress(newProgress);
      props.setStep(4);
      let temp = { ...props.isCompleted };
      temp.experience = true;
      props.setIsCompleted(temp);
      props.switchComponent("orgQuestions");
      props.gotoSlide(3);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };
    const handleFinal = async () => {
        if (handleValidation()) {
            let temp = {...props.isCompleted, experience: true};
            props.setIsCompleted(temp);
            const completeData = {...props.candidate, ...experience};
            props.setCandidate(completeData);
            await props.handleSubmit(completeData);
        } else {
            NotificationManager.error("Please fill in all the required fields.");
        }
    };

  return (
    <div className="d-flex justify-content-between">
      <Col className=" px-lg-2 mt-lg-2 pt-lg-2">
        <div className={"text-center"}>
          <h3 className="secondary-heading">Internships and Experience</h3>
        </div>
          {isFieldEnabled("internshipDetails") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("internshipDetails")} :{" "}
                              {/* Mention details of any internships (company name, department and
                  year of internship). */}
                          </strong>
                      </Label>
                      <textarea
                          className={"form-control input-grey"}
                          placeholder={theLabelName("internshipDetails")}
                          name={"internshipDetails"}
                          value={experience?.internshipDetails}
                          style={{
                              borderRadius: "10px",
                          }}
                          onChange={(e) => handleChange(e)}
                      ></textarea>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("yearsOfExperience") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("yearsOfExperience")} :{" "}
                                          {/* Years of experience (Excluding internships) : */}
                                          {/*<span className={"active-text"}>*</span>*/}
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name="yearsOfExperience"
                                      options={years}
                                      value={getSelectedObject(
                                          experience?.yearsOfExperience,
                                          years
                                      )}
                                      onChange={(e) => {
                                          setExperience({
                                              ...experience,
                                              yearsOfExperience: e?.value,
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("companyName") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("companyName")} :{" "}
                                          {/* Current Company Name :  */}
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                                      className={"input-grey"}
                                      placeholder={theLabelName("companyName")}
                                      name={"companyName"}
                                      value={experience?.companyName}
                                      onChange={(e) => handleChange(e)}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}

          <Row className="grid-row mt-4">
              {isFieldEnabled("department") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("department")} :{" "}
                                          {/* Department :  */}
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                                      className={"input-grey"}
                                      placeholder={theLabelName("department")}
                                      name={"department"}
                                      value={experience?.department}
                                      onChange={(e) => handleChange(e)}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}
              {isFieldEnabled("designation") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("designation")} :{" "}
                                          {/* Designation :  */}
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                                      className={"input-grey"}
                                      placeholder={theLabelName("designation")}
                                      name={"designation"}
                                      value={experience?.designation}
                                      onChange={(e) => handleChange(e)}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}
        </Row>
          {isFieldEnabled("currentEmployer") && (
        <Row className={"mt-4"}>
          <Col md={12}>
            <Label className={"w-100 text-left ml-3"}>
              <strong>
                  {theLabelName("currentEmployer")} :{" "}
                  {/* If currently employed, please indicate your total tenure with
                your current employer. */}
              </strong>
            </Label>
            <textarea
              className={"form-control input-grey"}
              placeholder={theLabelName("currentEmployer")}
              name={"currentEmployer"}
              value={experience?.currentEmployer}
              onChange={(e) => handleChange(e)}
              style={{
                borderRadius: "10px",
              }}
            ></textarea>
          </Col>
        </Row>
          )}
        <Row className={"mt-4"}>
          <Col>
            <Button
              className="nextBtn startButton float-left"
              color={""}
              onClick={() => {
                  // props.switchComponent("education");
                  props.switchBack();
                  // props.setProgress(33);
                  const newProgress = Math.max(
                      (props.progress || 0) - props.progressIncrement,
                      0
                  ); // Ensure progress doesn’t go below 0
                  props.setProgress(newProgress);
                props.setStep(2);
                props.gotoSlide(1);
              }}
            >
              <span className="text-white font-weight-normal">Back</span>
            </Button>
              {/* <Button
              className="beginBtn startButton float-right"
              color=""
              onClick={() => handleNext()}
            >
              <span className="text-white font-weight-normal">Next</span>
            </Button> */}
              <Button
                  className="beginBtn startButton float-right"
                  color=""
                  onClick={(e) => {
                      if (props?.lastComponent) {
                          handleFinal();
                      } else {
                          handleNext();
                      }
                  }}
              >
              <span className="text-white font-weight-normal">
                {props.lastComponent ? (
                    <>
                        {props.isLoading ? (
                            <Spinner color="light" size="sm"/>
                        ) : (
                            "Submit"
                        )}
                    </>
                ) : (
                    <>Next</>
                )}
              </span>
            </Button>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default Experience;
